import HomePage from "../components/Home/HomePage";

export function Homepage() {
  return (
    <div>
      <HomePage />
    </div>
  );
}

export default Homepage;
